/* @flow */
import React from 'react';
import TreasurerAddBankAccount from 'payments/components/TreasurerAddBankAccount.jsx';
import WindowDialog from 'components/WindowDialog.jsx';
import cx from 'classnames';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';

export default class TreasurerAddBankAccountModal extends React.Component {
  static propTypes = {
    connectedBankAccount: React.PropTypes.instanceOf(ConnectedBankAccount),
    onBankAccountAdded: React.PropTypes.func,
    onRequestHide: React.PropTypes.func,
  }

  onBankAccountAdded = () => {
    this.props.onRequestHide();
    this.props.onBankAccountAdded();
  }

  render () {
    const { className, connectedBankAccount, ...rest } = this.props;
    return (
      <WindowDialog
        {...rest}
        size="medium"
        className={cx('TreasurerAddBankAccountModal', className)}>
        <TreasurerAddBankAccount
          {...rest}
          onBankAccountAdded={this.onBankAccountAdded}
          connectedBankAccount={connectedBankAccount}
        />
      </WindowDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerAddBankAccountModal.jsx